export default __webpack_public_path__ + "static/media/circle-1.09948f35.svg";